import { variableNodesToPlaceholders } from './htmlTemplateVariables';

const htmlTemplateParse = (html: any) => {
    if (!html || typeof html !== 'string') {
        return html;
    }

    return variableNodesToPlaceholders(html);
};

const exportedObject = {
    htmlTemplateParse
};

export default exportedObject;
